import { IFilterBuilder } from '@/shared/filters/filter-builder.interfaces';
import { TFilterConfig } from '@/shared/filters/hooks/use-direct-filter/use-direct-filter.types';

export const useDirectFilter = <T>(
  filterBuilder?: IFilterBuilder<T>,
  filters?: Partial<Record<keyof T, string | string[] | TFilterConfig>>,
): T | undefined => {
  if (!filterBuilder) {
    return undefined;
  }

  const constructFilter = () => {
    filterBuilder.reset();

    if (!filters) {
      return filterBuilder.build();
    }

    Object.keys(filters).forEach((key) => {
      const filterKey = key as keyof T;
      const filterEntry = filters[filterKey];

      if (!filterBuilder.allowedFilters.includes(filterKey) || !filterEntry) {
        return;
      }

      if (typeof filterEntry === 'string') {
        filterBuilder.applyFilter(filterKey, filterEntry);
      } else if (Array.isArray(filterEntry)) {
        filterBuilder.applyFilter(filterKey, filterEntry, 'in');
      } else if (typeof filterEntry === 'object') {
        const { value, method } = filterEntry;

        if (!value) {
          return;
        }

        if (method === 'in' && !Array.isArray(value)) {
          const arrayValue = (value as string)
            .split(',')
            .map((v) => v.trim())
            .filter(Boolean);

          filterBuilder.applyFilter(filterKey, arrayValue, method);
        } else {
          filterBuilder.applyFilter(filterKey, value, method);
        }
      }
    });

    return filterBuilder.build();
  };

  return constructFilter();
};
